import React, { useEffect, useState, useMemo } from "react"
import { MaterialReactTable, useMaterialReactTable } from "material-react-table"
import {
  TextField,
  createTheme,
  ThemeProvider,
  useTheme,
  Box,
  IconButton,
  Tooltip,
  TablePagination,
} from "@mui/material"

import Swal from "sweetalert2"
import { styled } from "@mui/material/styles"
import { esES } from "@mui/material/locale"
import { MRT_Localization_ES } from "material-react-table/locales/es"
import fetchwrapper from "../../../services/interceptors/fetchwrapper"
import EditIcon from "@mui/icons-material/Edit"
import { useNavigate } from "react-router-dom"
import EliminarIcon from "../../../assets/iconos/Eliminar.ico"
import DetalleIcon from "../../../assets/iconos/Detalle.ico"
import normalFormatDate from "../../utils/date/DDMMYYYFormatDate"
import normalFormatHour from "../../utils/date/HHMMSSFormatHour"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import CustomBackdrop from "../../../components/CustomBackdrop"
const CustomTable = ({
  fetchedInfo = [],
  isLoadingInfoError,
  isLoadingInfo,
  isFetchingInfo,
  searchAttempted,
  setAsociaciones,
  refetch,
  onPageChange,
  deleteFunction,
}) => {
  const navigate = useNavigate()
  // Maneja cambios en los filtros de la grilla

  const columns = useMemo(
    () => [
      {
        accessorKey: "acciones",
        header: "Acciones",
        enableColumnFilter: false,
        size: 150,
        Cell: ({ row }) => (
          <Box sx={{ display: "flex", gap: "1rem" }}>
            <Tooltip title="Editar">
              <IconButton
                onClick={() => {
                  setTimeout(() => {
                    navigate(`editar/Asociaciones`, { state: row.original })
                  }, 0)
                }}
              >
                <img src={DetalleIcon} alt="Editar" style={{ width: "20px" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Eliminar">
              <IconButton color="error" onClick={() => deleteFunction(row)}>
                <img src={EliminarIcon} alt="Grabar" style={{ width: "20px" }} />
              </IconButton>
            </Tooltip>
          </Box>
        ),
      },
      {
        accessorKey: "ciacodigo",
        header: "CIA",
        enableEditing: false,
        size: 120,
      },

      {
        accessorKey: "bodcodigo",
        header: "Codigo Bodega",
        enableEditing: false,
        size: 120,
      },
      {
        accessorKey: "boddescri",
        header: "Descripcion Bodega",
        enableEditing: false,
        size: 120,
      },

      {
        accessorKey: "artcodigo",
        header: "Articulo",
        enableEditing: false,
        size: 120,
      },
      {
        accessorKey: "artdescri",
        header: "Descripcion",
        enableEditing: false,
        size: 120,
      },
      {
        accessorKey: "embcodigo",
        header: "Embalaje",
        enableEditing: false,
        size: 120,
      },
      {
        accessorKey: "embdescripcion",
        header: "Embalaje",
        enableEditing: false,
        size: 120,
      },
      {
        accessorKey: "clicodigo",
        header: "Cliente",
        enableEditing: false,
        size: 120,
      },
      {
        accessorKey: "clinombre",
        header: "Nombre Cliente",
        enableEditing: false,
        size: 120,
      },
      {
        accessorKey: "condescri",
        header: "Contacto",
        enableEditing: false,
        size: 120,
      },
      {
        accessorKey: "agecodigo",
        header: "Codigo Agencia",
        enableEditing: false,
        size: 200,
      },
      {
        accessorKey: "agendescri",
        header: "Descripcion Agencia",
        enableEditing: false,
        size: 200,
      },
    ],
    [navigate],
  )

  const table = useMaterialReactTable({
    columns,
    data: fetchedInfo.length > 0 ? fetchedInfo : [],
    enableEditing: false,
    enableRowActions: false,
    localization: { ...MRT_Localization_ES },
    initialState: {
      showColumnFilters: true,
    },
    getRowId: (row) => row.formcodigo,
    muiToolbarAlertBannerProps:
      searchAttempted && !isLoadingInfo && fetchedInfo.length === 0 && !isFetchingInfo
        ? {
            color: "info",
            children: "No se encontraron Asociaciones",
          }
        : undefined,
    muiTableContainerProps: {
      sx: {
        minHeight: "500px",
      },
    },
    renderToolbarInternalActions: ({ table }) => <Box></Box>,

    state: {
      isLoading: isLoadingInfo,
      showAlertBanner: isLoadingInfoError,
      showProgressBars: isFetchingInfo,
    },
  })

  return (
    <>
      <MaterialReactTable table={table} />
    </>
  )
}

const GridAsociacion = ({
  refetch,
  fetchedInfo,
  isLoadingInfo,
  isError,
  isFetchingInfo,
  setAsociaciones,
  deleteFunction,
  searchAttempted,
}) => {
  const theme = useTheme()

  // Maneja cambios en los filtros de la grilla

  return (
    <div>
      <ThemeProvider theme={createTheme(theme, esES)}>
        <CustomTable
          fetchedInfo={fetchedInfo}
          isLoadingInfoError={isError}
          isLoadingInfo={isLoadingInfo}
          isFetchingInfo={isFetchingInfo}
          refetch={refetch}
          setAsociaciones={setAsociaciones}
          deleteFunction={deleteFunction}
          searchAttempted={searchAttempted}
        />
      </ThemeProvider>
    </div>
  )
}

export default GridAsociacion
